/* eslint-disable arrow-body-style */
export const isClient = () => typeof window !== 'undefined';
